import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Tooltip, IconButton } from '@material-ui/core';
import MessageIcon from '@material-ui/icons/Message';
import Typography from '@material-ui/core/Typography';

// import { getPpsiById } from '../../../features/PpsiContainer/selectors';
import DataTypes from '../../Table/dataTypes';
import Table from '../../Table/Table';
import { getIsGlobalUser } from 'features/loginSystem/selectors';
// import { toJS } from 'utils/immutableUtils';
import { getLanguage } from 'features/app/selectors';
import { getMarketLanguage } from 'features/app/selectors';
import FormContext from '../../Form/FormContext';
import { makeStyles } from '@material-ui/core/styles';

function getPpsiHistory(ppsi) {
  return ppsi.ppsiHistory;
}

const useStyles = makeStyles(theme => ({
  tooltip: {
    maxWidth: 450,
    backgroundColor: '#000'
  }
}));

const HistoryTabContent = () => {
  const classes = useStyles();
  const { data, completePpsiData } = useContext(FormContext);
  // const { ppsiId } = data;
  const isGlobalUser = useSelector(getIsGlobalUser);
  const languages = useSelector(getLanguage);
  // const localPpsi = useSelector(getPpsiById(ppsiId));
  // const ppsi = toJS(localPpsi, []);
  const marketLanguage = useSelector(getMarketLanguage);

  const language = isGlobalUser ? marketLanguage : languages;

  const history = getPpsiHistory(completePpsiData);
  const historyData = history === null ? [] : history;

  const HistoryColumns = {
    PresentationName: {
      name: 'presentationName',
      calculateCellValue: rowData => rowData.info[language].presentation_name,
      //   filterable: true,
      sortable: true,
      label: 'Product Name',
      width: 300,
      grow: 0,
      shrink: 0
    },
    Action: {
      name: 'status',
      dataField: 'status',
      label: 'Decision',
      sortable: false,
      width: 140,
      grow: 0,
      shrink: 0
    },
    Version: {
      name: 'version',
      dataField: 'version',
      label: 'Version',
      width: 60,
      sortable: false,
      filterable: false,
      grow: 0,
      shrink: 0
    },
    Comment: {
      name: 'comment',
      label: 'Comments',
      // dataField: 'comment',
      width: 220,
      sortable: false,
      grow: 0,
      shrink: 0,
      calculateCellValue: rowData => {
        const comment =
          !rowData.comment && rowData.comment === null ? '' : rowData.comment;
        return (
          <>
            {comment.length > 50 ? (
              <>
                <Typography variant="body2">
                  {comment.slice(0, 15)}...
                </Typography>
                <Tooltip
                  classes={{ tooltip: classes.tooltip }}
                  title={
                    <Typography variant="body2" fontSize={20}>
                      {comment}...
                    </Typography>
                  }
                >
                  <IconButton color="action" size="medium">
                    <MessageIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </>
            ) : (
              comment
            )}
          </>
        );
      }
    },
    ReviewSentDate: {
      name: 'reviewSendDate',
      dataField: `reviewSendDate`,
      dataType: DataTypes.Date,
      label: 'Date',
      sortable: false,
      filterable: false,
      width: 100,
      grow: 0,
      shrink: 0
    },
    ActionDate: {
      name: 'decisionDate',
      dataField: `decisionDate`,
      dataType: DataTypes.Date,
      label: 'Decision Date',
      searchable: false,
      sortable: false,
      width: 100,
      grow: 0,
      shrink: 0
    },
    MarketUser: {
      name: 'byMarketUser',
      label: 'Market User',
      calculateCellValue: rowData => {
        return rowData.byMarketUser !== null
          ? rowData.byMarketUser.includes('IFOOD')
            ? rowData.byMarketUser.slice(6)
            : rowData.byMarketUser.slice(5)
          : null;
      },
      sortable: false,
      filterable: false,
      width: 100,
      grow: 0,
      shrink: 0
    },
    GlobalUser: {
      name: 'byGlobalUser',
      label: 'Global User',
      calculateCellValue: rowData => {
        return rowData.byGlobalUser !== null
          ? rowData.byGlobalUser.includes('IFOOD')
            ? rowData.byGlobalUser.slice(6)
            : rowData.byGlobalUser.slice(5)
          : null;
      },
      sortable: false,
      filterable: false,
      width: 130,
      grow: 0,
      shrink: 0
    },
    EmptySpace: {
      name: 'itemCode',
      dataField: 'itemCode',
      label: '  ',
      width: 10,
      grow: 0,
      shrink: 0
    }
  };

  return (
    <div style={{ height: '600px' }}>
      <Table
        title="ppsi.historyTab"
        data={historyData}
        columns={[
          HistoryColumns.PresentationName,
          HistoryColumns.Version,
          HistoryColumns.ReviewSentDate,
          HistoryColumns.MarketUser,
          HistoryColumns.Action,
          HistoryColumns.ActionDate,
          HistoryColumns.GlobalUser,
          HistoryColumns.Comment
          // HistoryColumns.EmptySpace
        ]}
        getObjectId={object => object.id}
        // defaultSorting={[{ columnName: 'version', direction: 'asc' }]}
        selectable={false}
        toolbarVisible={false}
      />
    </div>
  );
};

export default HistoryTabContent;
